// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__HQlLt","title":"InfoRow_title__27zZK"};